import { capitalize } from "lodash";
import { CATEGORIES } from "./names";
import zxcvbn from "zxcvbn";

export class RoomNameService {
  public static roomNameCheckCache = new Map<string, zxcvbn.ZXCVBNResult>();
  public static ROOM_NAME_LENGTH = 100;
  public static PATTERNS = [
    "_ADJECTIVE__PLURALNOUN__VERB__ADVERB_"
    // BeautifulFungiOrSpaghetti
    //    '_ADJECTIVE__PLURALNOUN__CONJUNCTION__PLURALNOUN_',

    // AmazinglyScaryToy
    //    '_ADVERB__ADJECTIVE__NOUN_',

    // NeitherTrashNorRifle
    //    'Neither_NOUN_Nor_NOUN_',
    //    'Either_NOUN_Or_NOUN_',

    // EitherCopulateOrInvestigate
    //    'Either_VERB_Or_VERB_',
    //    'Neither_VERB_Nor_VERB_',

    //    'The_ADJECTIVE__ADJECTIVE__NOUN_',
    //    'The_ADVERB__ADJECTIVE__NOUN_',
    //    'The_ADVERB__ADJECTIVE__NOUN_s',
    //    'The_ADVERB__ADJECTIVE__PLURALNOUN__VERB_',

    // WolvesComputeBadly
    //    '_PLURALNOUN__VERB__ADVERB_',

    // UniteFacilitateAndMerge
    //    '_VERB__VERB_And_VERB_',

    // NastyWitchesAtThePub
    //    '_ADJECTIVE__PLURALNOUN_AtThe_PLACE_',
  ];

  public static generateRandomName(
    patterns: string[] = RoomNameService.PATTERNS
  ): string {
    let name = RoomNameService.randomElement(patterns);

    while (RoomNameService.hasTemplate(name)) {
      for (const template in CATEGORIES) {
        const word = capitalize(
          RoomNameService.randomElement(CATEGORIES[template])
        );
        name = name.replace(template, word);
      }
    }

    return name;
  }

  public static isUnsafeRoomName(roomName: string): boolean {
    const result = RoomNameService.checkRoomName(roomName);
    return (
      roomName.length < RoomNameService.ROOM_NAME_LENGTH && result.score < 3
    );
  }

  public static checkRoomName(roomName: string): zxcvbn.ZXCVBNResult {
    if (RoomNameService.roomNameCheckCache.has(roomName)) {
      return RoomNameService.roomNameCheckCache.get(roomName)!;
    }
    const result = zxcvbn(roomName);
    RoomNameService.roomNameCheckCache.set(roomName, result);
    return result;
  }

  private static hasTemplate(s: string): boolean {
    for (const template in CATEGORIES) {
      if (s.indexOf(template) >= 0) {
        return true;
      }
    }

    return false;
  }

  private static randomElement(arr: any[] | string): any {
    return arr[RoomNameService.randomInt(0, arr.length - 1)];
  }

  private static randomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
